import { Competition } from '../../../../features/Competition/types';
import { tradingCompetitionApi } from '../../clients/clients';
import { GetCompetitionsRequest } from '../../generated';
import { toCompetition } from './toCompetition';

const getKey = (params: GetCompetitionsRequest) => {
  return ['tradingCompetitionApi.getCompetitions', params];
};

const getFn = (params: GetCompetitionsRequest) => async () => {
  const rawResponse = await tradingCompetitionApi.getCompetitionsRaw(params);
  const data = await rawResponse.value();
  
return data.map(toCompetition);
};

export const getCompetitionsQuery = {
  getKey,
  getFn,
};

export namespace GetCompetitionsQuery {
  export type Param = GetCompetitionsRequest;
  export type Response = Competition[];
}

